<template>
  <div>
    <ts-select-teacher v-model="teacher_id" />
  </div>
</template>

<script>
import TsSelectTeacher from '@/components/SelectTeacher'
export default {
  name: 'chooseTeacher',
  components: { TsSelectTeacher },
  computed: {
    teacher_id: {
      get() {
        return this.$store.state.home.staffHomework.teacher_id
      },
      set(val) {
        this.$store.commit('home/staffHomework/SET_TEACHER_ID', val)
      }
    }
  }
}
</script>
